export const config = {
  eventGroup: 'jxsj4MO20251226',
  name: '《剑侠世界4》分流页建设MO',
  identify: 'js4',
  eventTags: ['jxsj4', 'js4']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    miniAppLoad: function() {
      report({
        eventName: 'mini_app_load',
        eventDescription: '小程序启动(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    miniAppPageLoad: function() {
      report({
        eventName: 'mini_app_page_load',
        eventDescription: '小程序页面启动(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    miniAppShow: function() {
      report({
        eventName: 'mini_app_show',
        eventDescription: '小程序显示(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    miniAppPageShow: function() {
      report({
        eventName: 'mini_app_page_show',
        eventDescription: '小程序页面显示(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    miniAppHide: function() {
      report({
        eventName: 'mini_app_hide',
        eventDescription: '小程序隐藏(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    miniAppPageHide: function() {
      report({
        eventName: 'mini_app_page_hide',
        eventDescription: '小程序页面隐藏(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    miniAppPageShare: function() {
      report({
        eventName: 'mini_app_page_share',
        eventDescription: '小程序页面触发分享(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 顶部通栏、首页、底部
     */
    clickReservation: function(title) {
      report({
        eventName: 'click_reservation',
        eventDescription: '点击立即预约',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickPopupPhoneReserve: function() {
      report({
        eventName: 'click_popup_phone_reserve',
        eventDescription: '点击弹窗手机号预约'
      });
    },
    /**
     * @param {string} [status] - 成功：success  失败：fail
     */
    phoneReservation: function(status) {
      report({
        eventName: 'phone_reservation',
        eventDescription: '手机号立即预约',
        eventDataValue: {
          status: status
        },
        types: {
          status: checkTypeHOF('string')
        }
      });
    },
    clickGetVerifyCode: function() {
      report({
        eventName: 'click_get_verify_code',
        eventDescription: '获取验证码'
      });
    },
    clickPopupQrcodeReservation: function() {
      report({
        eventName: 'click_popup_qrcode_reservation',
        eventDescription: '点击弹窗扫码预约'
      });
    },
    clickGoReservation: function() {
      report({
        eventName: 'click_go_reservation',
        eventDescription: '点击弹窗扫码预约-前往预约'
      });
    },
    clickDownloadGame: function() {
      report({
        eventName: 'click_download_game',
        eventDescription: '点击下载游戏'
      });
    },
    clickOfficialRecharge: function() {
      report({
        eventName: 'click_official_recharge',
        eventDescription: '点击官方充值'
      });
    },
    clickRewardInquiry: function() {
      report({
        eventName: 'click_reward_inquiry',
        eventDescription: '点击资格&奖励查询'
      });
    },
    scanOfficialAccount: function() {
      report({
        eventName: 'scan_official_account',
        eventDescription: '微信公众号扫码'
      });
    },
    scanGameDouyin: function() {
      report({
        eventName: 'scan_game_douyin',
        eventDescription: '官网抖音扫码'
      });
    },
    scanCustomerService: function() {
      report({
        eventName: 'scan_customer_service',
        eventDescription: '客服管家扫码'
      });
    },
    scanGameWeibo: function() {
      report({
        eventName: 'scan_game_weibo',
        eventDescription: '游戏微博扫码'
      });
    },
    clickGuanwang: function() {
      report({
        eventName: 'click_guanwang',
        eventDescription: '点击进入官网'
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
